/** Canonical assignable entries in agent_versions.builtin_tools (never callable family members). */
export const CHANNELS_PERMISSION = 'company_channels';
export const SANDBOX_TOOL_NAMES = [
  'sandbox_exec',
  'sandbox_read_file',
  'sandbox_write_file',
  'sandbox_list',
  'sandbox_edit',
  'sandbox_grep',
  'sandbox_glob',
] as const;
export const BUILTIN_TOOL_NAMES = [
  'report_result',
  'ask_human',
  'memory_search',
  'memory_write',
  'delegate_task',
  'spawn_subagent',
  'send_message_to_agent',
  'get_message_status',
  'queue_next_tasks',
  'skill_propose',
  'get_run_status',
  CHANNELS_PERMISSION,
  'manage_company',
  'manage_triggers',
  ...SANDBOX_TOOL_NAMES,
] as const;
export type BuiltinToolName = (typeof BUILTIN_TOOL_NAMES)[number];
export const DEFAULT_BUILTIN_TOOLS: BuiltinToolName[] = [
  'report_result',
  'ask_human',
  'memory_search',
  'memory_write',
];
export const isBuiltinCapability = (name: string): name is BuiltinToolName =>
  (BUILTIN_TOOL_NAMES as readonly string[]).includes(name);

/** Resolved callable names are distinct from stored capabilities. Denied families cannot be passed on. */
export function builtinCapabilities(listed: readonly string[], visible: readonly string[]): string[] {
  const held = listed.length ? listed : DEFAULT_BUILTIN_TOOLS;
  return BUILTIN_TOOL_NAMES.filter((name) => {
    if (!held.includes(name) && name !== 'report_result') return false;
    if (name === CHANNELS_PERMISSION) return visible.some((t) => t.startsWith('channel_'));
    if (name === 'manage_company') return visible.includes('company_update_agent');
    if (name === 'manage_triggers') return visible.includes('company_update_trigger');
    return visible.includes(name);
  });
}
